import _defineProperty from "/var/jenkins_home/workspace/tingle.b462fce8-c3fd-4157-817f-5a1715b99180/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _BannerTypeToColorSet;

// ignore-string-externalization
import React from 'react';
import { Banner as EncoreBanner, spacer, breakpoint } from '@spotify-internal/encore-web';
import styled, { css } from 'styled-components';
import { BannerType } from './BannerState';
import { useBannerActions } from './useBannerActions';
import { jsx as _jsx } from "react/jsx-runtime";
var appMaxWidth = '100vw';
var BannerTypeToColorSet = (_BannerTypeToColorSet = {}, _defineProperty(_BannerTypeToColorSet, BannerType.WARNING, 'warning'), _defineProperty(_BannerTypeToColorSet, BannerType.ANNOUNCEMENT, 'announcement'), _defineProperty(_BannerTypeToColorSet, BannerType.ERROR, 'negative'), _defineProperty(_BannerTypeToColorSet, BannerType.SUCCESS, 'positive'), _defineProperty(_BannerTypeToColorSet, BannerType.INFO, undefined), _BannerTypeToColorSet);
var BannerWrapper = styled.div.withConfig({
  displayName: "Banner__BannerWrapper",
  componentId: "etakaq-0"
})(["position:absolute;z-index:3;@media (max-width:", "){top:42px;height:90px;}@media (min-width:", "){top:66px;height:110px;}@media (min-width:", "){top:76px;height:110px;}@media (min-width:", "){", ";max-width:", ";width:100%;& > *{border-radius:", ";}}"], breakpoint.screenXsMax, breakpoint.screenSmMin, breakpoint.screenMdMin, breakpoint.screenSmMin, function (props) {
  return props.compact ? css(["margin:0;padding:0;"]) : css(["margin-bottom:", ";margin-left:auto;margin-right:auto;padding-left:", ";padding-right:", ";"], spacer.spacer24, spacer.spacer48, spacer.spacer48);
}, appMaxWidth, function (props) {
  return props.compact ? '0' : '4px';
});
export var Banner = function Banner(_ref) {
  var singleBannerState = _ref.singleBannerState;

  var _useBannerActions = useBannerActions(),
      hide = _useBannerActions.hide;

  var onHide = function onHide(bannerId) {
    var _singleBannerState$op, _singleBannerState$op2;

    var handled = (_singleBannerState$op = (_singleBannerState$op2 = singleBannerState.options).onHide) === null || _singleBannerState$op === void 0 ? void 0 : _singleBannerState$op.call(_singleBannerState$op2);

    if (!handled) {
      hide(bannerId);
    }
  };

  return /*#__PURE__*/_jsx(BannerWrapper, {
    compact: singleBannerState.options.compact,
    children: /*#__PURE__*/_jsx(EncoreBanner, {
      "data-testid": "banner-".concat(singleBannerState.id),
      colorSet: BannerTypeToColorSet[singleBannerState.type],
      onClose: singleBannerState.options.showDismissButton ? function () {
        return onHide(singleBannerState.id);
      } : undefined,
      children: singleBannerState.message
    })
  });
};